import mitt from 'mitt'

const emitter = mitt()

export const EmitterEventTypes = {
    CLIENT_TOKEN_UPDATED: 'client-token-updated',
};

export default emitter;
